import styled from "@emotion/styled";
import * as spacing from "src/styles/constants/spacing";

export const TableContainer = styled.div`
  width: calc(100vw - 6em);
  height: calc(100vh - 11em);
  overflow: auto;
  position: relative;
  z-index: 0;
  margin-left: -${spacing.space_m};
`;

export const GridWrapper = styled.div`
  height: 100%;
  width: 100%;
`;
